export const html = "<p>Taste the finest sweets by Yeremyan Products.</p>\n";
export const leadHtml = "<p>Taste the finest sweets by Yeremyan Products.</p>\n";
export const bodyHtml = "";
export const metaText = "Taste the finest sweets by Yeremyan Products.";